@if (isLoggedIn === false) {
    <button
        type="button"
        class="dyn-xyz-app-header_login-button"
        (click)="dynRemote.callLogin()">
        {{'components.dynamic-xyz.login_button' | l10n}}
    </button>
} @else {
    @if (walletSelectItems && walletFormControl) {
        <button
            class="dyn-xyz-app-header_wallet-select-btn"
            [dynWalletItems]="walletSelectItems"
            (walletClick)="walletFormControl.setValue($event)"
            (profileClick)="profileClick()"
            (logoutClick)="logoutClick()">

            <wallet-avatar class="dyn-xyz-app-header_wallet-select-btn-avatar" [address]="walletFormControl.value"></wallet-avatar>
            {{walletFormControl.value | shortenWalletAddr}}
        </button>
    }
}
